export const getApiBaseUrl = () => {
    const isProduction = process.env.NODE_ENV === 'production';
    return isProduction
        ? process.env.REACT_APP_API_URL_LIVE
        : process.env.REACT_APP_API_URL_LOCAL;
};
